import withOnWatched from '../../elements/CustomResetPlayer/withOnWatched'
import ThriveAudioResetPlayer from './ThriveAudioResetPlayer'

export const ThriveAudioResetPlayerWithOnWatched = withOnWatched(
    ThriveAudioResetPlayer
)
